import React, { useState } from "react";
import Spinner from "components/Spinner/Spinner";
import { httpClient } from "common/httpClient";
import { useQueryString } from "common/effects";

export function TokenResponse() {
    const params = useQueryString();
    const [saved, setSaved] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [message, setMessage] = useState("Saving card details...");
    React.useEffect(() => {
        const saveCardDetails = async (request) => {
            await httpClient.post(`payments/tokenresponse`, request);
        };

        const transactionId = params.get("transaction_id");
        const merchantSession = params.get("merchant_session");
        const code = params.get("code");
        const message = params.get("message");
        const token = params.get("token");
        const panGuid = params.get("pan_guid");
        const panExpGuid = params.get("pan_exp_guid");
        const maskedCardNumber = params.get("masked_card_number");
        const expiryDate = params.get("expiry_date");

        const request = {
            transactionId,
            merchantSession,
            code,
            message,
            token,
            panGuid,
            panExpGuid,
            maskedCardNumber,
            expiryDate,
        };

        if (token && !processing) {
            const initIessage = {
                type: "TOKEN_INPROGRESS",
                payload: {
                    status: "In Progress",
                },
            };
            window.parent.postMessage(initIessage, "*");
            setProcessing(true);
            saveCardDetails(request)
                .then(() => {
                    setSaved(true);
                    setMessage(<div>Done</div>);
                    const message = {
                        type: "PROCESSING_COMPLETE",
                        payload: {
                            status: "success",
                        },
                    };
                    window.parent.postMessage(message, "*");
                })
                .catch((error) => {
                    setMessage("Error saving card details. Please contact support");
                });
        } else {
            console.error("Error saving card details. Please contact support");
        }
    }, [params, processing]);

    return (
        <div className="Tile-body-message">
            {!saved && <Spinner dark />}
            <div className="lead">{message}</div>
        </div>
    );
}
